import Promise from 'bluebird';
import _ from 'underscore';

function processFilterIds(ids) {
  return _.map(ids, id => ({
    Id: id,
    Name: id,
  }));
}

export class DisplayDomainDataSource {
  constructor({
    dataService,
  }) {
    this.auctionInsightService = dataService;
  }

  get(viewFilter, searchFilter, ids) {
    const data = this.auctionInsightService.getNormalizedData();
    let displayDomains = _.filter(_.unique(_.pluck(data, 'DisplayDomain')), domain => domain !== 'You');
    if (searchFilter) {
      displayDomains =
          _.filter(displayDomains, displayDomain => displayDomain.indexOf(searchFilter) >= 0);
    }

    if (ids) {
      displayDomains = _.intersection(displayDomains, ids);
    }

    return Promise.resolve(processFilterIds(displayDomains));
  }

  getByIds(ids = []) {
    return Promise.resolve(processFilterIds(ids));
  }
}
